module.exports = __webpack_public_path__ + "img/banner4.e2b75086.jpg";